/**
 * @file
 * @prettier
 */

import { InitializeSurveyPages } from "./surveyPages.js";

export function InitializeSecureBorrowerSurveyEmailSurveyPage() {
  InitializeSurveyPages();
}
